export const ESD_BLOCK_BUTTON = 'esd-block-button';
export const ESD_BLOCK_TEXT = 'esd-block-text';
export const ESD_BLOCK_IMAGE = 'esd-block-image';
export const ESD_BLOCK_STRUCTURE = 'esd-structure';
export const ESD_BLOCK_VIDEO = 'esd-block-video';
export const ESD_BLOCK_SOCIAL = 'esd-block-social';
export const ESD_BLOCK_BANNER = 'esd-block-banner';
export const ESD_BLOCK_TIMER = 'esd-block-timer';
export const ESD_BLOCK_MENU = 'esd-block-menu';
export const ESD_BLOCK_HTML = 'esd-block-html';
export const ESD_BLOCK_SPACER = 'esd-block-spacer';
export const ESD_BLOCK_CONTAINER = 'esd-container-frame';
export const ESD_BLOCK_STRIPE = 'esd-stripe';
export const ESD_BLOCK_FORM = 'esd-amp-form';

export enum BlockName {
  BUTTON = ESD_BLOCK_BUTTON,
  TEXT = ESD_BLOCK_TEXT,
  IMAGE = ESD_BLOCK_IMAGE,
  STRUCTURE = ESD_BLOCK_STRUCTURE,
  VIDEO = ESD_BLOCK_VIDEO,
  SOCIAL = ESD_BLOCK_SOCIAL,
  BANNER = ESD_BLOCK_BANNER,
  TIMER = ESD_BLOCK_TIMER,
  MENU = ESD_BLOCK_MENU,
  HTML = ESD_BLOCK_HTML,
  SPACER = ESD_BLOCK_SPACER,
  CONTAINER = ESD_BLOCK_CONTAINER,
}

export enum BlockSelector {
  BUTTON = `.${ESD_BLOCK_BUTTON}`,
  TEXT = `.${ESD_BLOCK_TEXT}`,
  IMAGE = `.${ESD_BLOCK_IMAGE}`,
  STRUCTURE = `.${ESD_BLOCK_STRUCTURE}`,
  VIDEO = `.${ESD_BLOCK_VIDEO}`,
  SOCIAL = `.${ESD_BLOCK_SOCIAL}`,
  BANNER = `.${ESD_BLOCK_BANNER}`,
  TIMER = `.${ESD_BLOCK_TIMER}`,
  MENU = `.${ESD_BLOCK_MENU}`,
  HTML = `.${ESD_BLOCK_HTML}`,
  SPACER = `.${ESD_BLOCK_SPACER}`,
  CONTAINER = `.${ESD_BLOCK_CONTAINER}`,
  STRIPE = `.${ESD_BLOCK_STRIPE}`,
  FORM = `.${ESD_BLOCK_FORM}`,
}
